import i18n from 'config/i18n';
import { isNil } from 'ramda';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

import { HexColor } from 'components/shared/ColorPickerPopover/ColorPickerPopover';

const getDuplicates = (arr, key) => {
  const keys = arr.map((item) => item[key]);
  return keys.filter((key) => keys.indexOf(key) !== keys.lastIndexOf(key));
};

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  code: yup.string().required(t('validation.valueIsRequired')),
  auxValueGroupId: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(t('validation.valueIsRequired')),
  notInUse: yup.boolean().optional(),
  sortOrder: yup.string().optional(),
  colorCode: yup.mixed<HexColor>().optional(),
  translations: yup.lazy((arr) => {
    if (isNil(arr)) {
      return yup.array();
    }
    return yup
      .array()
      .of(
        yup.object({
          languageCode: yup.string().required(t('validation.valueIsRequired')),
          name: yup.string().required(t('validation.valueIsRequired'))
        })
      )
      .test(
        'uniqueLanguageCode',
        t('auxValues.uniqueTranslationError'),
        (value) => {
          return !(getDuplicates(value, 'languageCode').length > 1);
        }
      )
      .required();
  })
});
